export default __webpack_public_path__ + "static/m-meeting-4ce7f77137a29167cc81dc96c57e8b68.jpg";